import request from '@/config/axios'

// PMS对接记录 VO
export interface PmsVO {
  id: string | number
  shopId: string | number
  pmsType: string
  syncType: string
  syncDirection: string
  syncStatus: number
  requestData: string
  responseData: string
  errorMsg: string
  syncTime: string
  duration: number
  remark: string
  createTime: Date
}

// 获取PMS对接记录分页
export function getPmsPage(params: any) {
  return request.get({ url: '/hotel/pms/page', params })
}
